import { eventBus, EVENTS } from '../commons/EventBus.js';
import API from "./Api.js";
import Utils from './utils.js';

const playingClass = 'is-playing';
let initialized = false;
window.is_oroscopo = false;

let array_songs_extended_player = Array();

window.object_podcast = {
    "rds-music-for-you-podcast" : {},
    "tutti-pazzi-per-rds-podcast" : {},
    "i-peggio-piu-peggio-di-rds" : {},
    "rds-motori" : {},
    "giornale-radio" : {},
    "100-secondi-con-enrico-mentana" : {},
    "100-secondi-con-carlo-rossella" : {},
    "gag-e-scherzi-di-rossella" : {},
    "gagdifrancesca" : {},
    "scherziciccio" : {},
    "il-meglio-di-anna-e-sergio" : {},
    "rds-i-grandi-della-musica" : {},
    "il-meglio-di-rds" : {},
    "il-meglio-di-petra-e-giovanni-peggio-di-rds" : {},
    "il-meglio-di-roberta-e-claudio" : {},
    "gag-e-scherzi-di-baz" : {},
    "gli-scherzi-di-tutti-pazzi-per-rds" : {},
    "lifestyle" : {},
    "oroscopo-di-branko" : {},
    "100-secondi-con-daniele-doesnt-matter" : {},
    "100-secondi-di-tecnologia" : {},
    "100-secondi-di-sport" : {},
    "100-made-in-italy": {},
    "rds-green": {},
    "alba-dei-pazzi-viventi-su-rds": {},
    "meteo": {},
    "sognando-rds": {}
}

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;
    if(!initialized){
        initPlayer();
        initialized=true;
    }
});



function initPlayer(){

    $(document).on('click','.podcast-play',(e) => {

        console.log(e);

        const audioSrc = $(e.currentTarget).attr('data-audio');
        const immagine = $(e.currentTarget).attr('data-cover') || "";
        const titolo = $(e.currentTarget).attr('data-titolo') || "";
        const category = $(e.currentTarget).attr('data-category') || "";
        const giorno = $(e.currentTarget).attr('data-giorno') || "";
        const id_elem = $(e.currentTarget).attr('data-id') || "";
        const type = $(e.currentTarget).attr('data-type') || "";
        const slug = $(e.currentTarget).attr('data-slug') || "";
        const category_slug = $(e.currentTarget).attr('data-catSlug') || "";
        const cover_to_overlay = $(e.currentTarget).parents(".blocco_podcast_audio").find(".cover_overlay");

        const podcast_object = {immagine: immagine,
                                titolo: titolo,
                                categoria: category,
                                giorno: giorno,
                                cover_to_overlay: cover_to_overlay,
                                id: id_elem,
                                type: type,
                                audioSrc:audioSrc,
                                slug:slug,
                                category_slug:category_slug
                                };

        console.log(playerPodcast.getSource());
        console.log(audioSrc);

        if (playerPodcast.getSource() == audioSrc && playerPodcast.playing()) {
            /// stop
            playerPodcast.stop();
        } else if (playerPodcast.getSource() == audioSrc) {
            /// play dopo aver messo pausa
            openPlayerBottom();
            playerPodcast.play();
        } else {
            /// play mentre altro è in play
            eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);             
            playerPodcast.setSource(audioSrc);    
            // let type = 'sample audio'; 
            // if(podcast_object.type == 'podcast'){
            //     type = 'podcast'; 
            // }
            // window.extensionPodcast.setParameter({
            //   customParams : {
            //     channel: '',
            //     format: 'audio',
            //     type: type,
            //   }
            // });
            playerPodcast.play();
            openPlayerBottom();

        }
            if((category_slug == "oroscopo-di-branko" && $(e.target).hasClass('is_oroscopo')) || $(e.target).hasClass('other_audio')){

                scrollInMiddle($(e.target));
                // $(".other_podcast").removeClass("current_pod");
                // $(".other_podcast").removeClass("prev_pod");
                // $(".other_podcast").removeClass("next_pod");
                // $(e.target).parents(".other_podcast").addClass("current_pod");
                // $(".current_pod").prevAll( ".other_podcast" ).addClass("prev_pod").hide();
                // $(".current_pod").nextAll( ".other_podcast" ).addClass("next_pod");

                checkIfLoadMore();
            } else{
                fillExtendedPlayer(type, category_slug, id_elem, ".podcast-play");
            }
            $("img.podcast_prev").removeClass("disabled");
            $("img.podcast_next").removeClass("disabled");

        // scrollElementPlay();
        showCurrentPrevNext()


    });

    $(document).on('click','.podcast-video-image', (e) => {

        const videoSrc = JSON.parse($(e.currentTarget).attr('data-video'));
        const immagine = "";
        const titolo = $(e.currentTarget).attr('data-titolo') || "";
        const category = $(e.currentTarget).attr('data-category') || "";
        const giorno = $(e.currentTarget).attr('data-giorno') || "";
        const id_elem = $(e.currentTarget).attr('data-id') || "";
        const catName = $(e.currentTarget).attr('data-catName') || "";

        const podcast_object = {
            immagine: immagine,
            titolo: titolo,
            categoria: catName,
            catSlug: category,
            giorno: giorno,
            id: id_elem,
            type: 'videoPodcast',
            videoSrc:videoSrc
        };

        eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);

        videoPlayer.setSources([videoSrc]);
        videoPlayer.play();

        $('#videoplayer').addClass('pip');

        setTimeout(async ()=>{
          await videoPlayer.container.rdsPip();
          videoPlayer.container.setAttribute("controls","controls");
        }, 500);

        // playerPodcast.setSources([videoSrc]);
        // playerPodcast.play();

        // setTimeout(async ()=>{
        //     try {
        //         await playerPodcast.container.requestPictureInPicture();
        //     } catch (error) {
        //         console.warn(error);
        //     }
        // },3000);

        // openPlayerBottom("podcast-video");
        //
        // fillExtendedPlayer("podcast-video", category, id_elem );

    });

    playerPodcast.on('resume', () => {
        const playables = $('.podcast-play');
        $('.podcast-play').removeClass(playingClass);
        for (let i = 0; i < playables.length; i++) {
            const playable = playables[i];
            if ($(playable).attr('data-audio') == playerPodcast.getSource()) {
                $(playable).addClass(playingClass);

            }

        }


    });

    playerPodcast.on('pause', () => {
        $('.podcast-play').removeClass(playingClass);

    });

}


function scrollInMiddle(me){
    $(".other_podcast").removeClass("current_pod");
    $(".other_podcast").removeClass("prev_pod");
    $(".other_podcast").removeClass("next_pod");
    me.parents(".other_podcast").addClass("current_pod");
    $(".current_pod").prevAll( ".other_podcast" ).addClass("prev_pod").hide();
    $(".current_pod").nextAll( ".other_podcast" ).addClass("next_pod");
    showAndHideButton();
}


function fillExtendedPlayer(type, category_slug, id_elem, css_class){

    $(".hide_for_trueview").css('visibility', 'visible');
    $(".hide_for_music_engine").css('visibility', 'visible');
    $(".show_for_trueview").hide();

    $(".extended_block").hide();
    $(".extended_block").removeClass("active");


    if(type=="podcast"){

        $("#playing_podcast_extended").show();
        $("#playing_podcast_extended").addClass("active");
        var cat_obj = window.object_podcast[category_slug];

        if(category_slug != "oroscopo-di-branko"){
            window.is_oroscopo = false;
            $("#link_ep_ext").show();
            $(".player_bottom_like").removeClass("hide_in_category");
            getPodcastListRelated(category_slug, id_elem);

        } else{
            window.is_oroscopo = true;
            $("#link_ep_ext").hide();
            $(".player_bottom_like").addClass("hide_in_category");
            getPodcastListRelated(category_slug, id_elem);

        }

    } else if(type=="podcast-video"){

        $("#playing_video_extended").show();
        $("#playing_video_extended").addClass("active");
        getPodcastVideoRelated(category_slug, id_elem);

    } else if(type == "song"){

        array_songs_extended_player = Array();

        $(css_class).each( function( index, element ){

            if(element) {
                array_songs_extended_player.push({
                    id: $(element).data("id"),
                    category: $(element).data("category"),
                    type: $(element).data("type"),
                    titolo: $(element).data("titolo"),
                    audio: $(element).data("audio"),
                    cover: $(element).data("cover"),
                    id_master_control: $(element).data("masterid")
                });
            }

        });

        var index = array_songs_extended_player.findIndex(function (song){return song.id == id_elem})

        var previus_id = -1;
        var next_id = -1;

        if(array_songs_extended_player[index - 1]) {
            $("#prev_song_play").find("img").attr("src", "https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i" + array_songs_extended_player[index - 1].id);
            $("#prev_song_play").find("span").text(array_songs_extended_player[index - 1].titolo + " - " + array_songs_extended_player[index - 1].category);
            previus_id = array_songs_extended_player[index - 1].id;
        } else {
            $("#prev_song_play").find("img").attr("src", "https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i" + array_songs_extended_player[array_songs_extended_player.length - 1].id);
            $("#prev_song_play").find("span").text(array_songs_extended_player[array_songs_extended_player.length - 1].titolo + " - " + array_songs_extended_player[array_songs_extended_player.length - 1].category);
            previus_id = array_songs_extended_player[array_songs_extended_player.length - 1].id;
        }

        if(array_songs_extended_player[index + 1]) {
            $("#next_song_play").find("img").attr("src", "https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i" + array_songs_extended_player[index + 1].id);
            $("#next_song_play").find("span").text(array_songs_extended_player[index + 1].titolo + " - " + array_songs_extended_player[index + 1].category);
            next_id = array_songs_extended_player[index + 1].id;
        } else {
            $("#next_song_play").find("img").attr("src", "https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i" + array_songs_extended_player[0].id);
            $("#next_song_play").find("span").text(array_songs_extended_player[0].titolo + " - " + array_songs_extended_player[0].category);
            next_id = array_songs_extended_player[0].id;
        }

        $("#in_riproduzione_song").find("img").attr("src","https://web.rds.it/i/jpeg/?url=https://web.rds.it/m/i"+id_elem);

        $("#in_riproduzione_song").attr("previus-id",previus_id);
        $("#in_riproduzione_song").attr("next-id",next_id);
        $("#in_riproduzione_song").attr("css_class",css_class);

        $("#playing_song_extended").show();
        $("#playing_song_extended").addClass("active");

    } else if(type == "gioco-video"){
      $("#playing_gioco_video_extended").show();
    }else if(type == "music-engine"){

        $("#playing_music_engine_extended").show();
    }

    // onclick="facebookShare({img: '{{share_img}}', title: '{{share_title}}', caption: '{{share_caption}}', url: '{{share_url}}'})"

    toggleCommands(type);

}

function toggleCommands(type){
    if(type == "song"){

        $(".container_cover_img").removeClass("video_command");
        $("#center_player_bottom").addClass("song_command");
        $("#action_bottom_cont").addClass("song_command");

    } else if(type == "podcast-video"){
        $(".container_cover_img").addClass("video_command");

    }else{
        $(".container_cover_img").removeClass("video_command");
        $("#center_player_bottom").removeClass("song_command");
        $("#action_bottom_cont").removeClass("song_command");
        if(window.innerWidth >= 650){


        }
    }
}

window.fillExtendedPlayer = fillExtendedPlayer;

window.clickPreviusSongExtendedPlayer=function(){
    if($("#playing_song_extended").hasClass("active")){
        var id = $("#in_riproduzione_song").attr("previus-id");
        var css_class = $("#in_riproduzione_song").attr("css_class");
        $(css_class + "[data-id='"+id+"']").trigger("click");

    } else if($("#playing_podcast_extended").hasClass("active")){
        $(".other_podcast.current_pod").prev().find(".podcast-play").trigger("click");

    } else if($("#playing_video_extended").hasClass("active")){
        if( $("#prev_podcast_play").find(".podcast-video-image").attr("data-video")){
            $("#prev_podcast_play").find(".podcast-video-image").trigger("click");
        }
    }
}

window.clickNextSongExtendedPlayer=function(){
    if($("#playing_song_extended").hasClass("active")) {
        var id = $("#in_riproduzione_song").attr("next-id");
        var css_class = $("#in_riproduzione_song").attr("css_class");
        $( css_class + "[data-id='"+id+"']").trigger("click");
    } else if($("#playing_podcast_extended").hasClass("active")){
        $(".other_podcast.current_pod").next().find(".podcast-play").click();
    } else if($("#playing_video_extended").hasClass("active")){
        if( $("#next_podcast_play").find(".podcast-video-image").attr("data-video")) {
            $("#next_podcast_play").find(".podcast-video-image").trigger("click");
        }
    }
};

function getPodcastListRelated(slug, id){

    $(".extend_player").css("visibility", "hidden");
    if(!slug){
        return;
    }
    if(slug != "oroscopo-di-branko"){
        var data={
            slug: slug,
            id_elem: id
        };
        API.get("site/getPodcastListRelated", data, function (resp) {
                if(resp.status==1){
                    console.log(resp);
                    fillListPodcast(resp.podcasts);
                    $(".extend_player").css("visibility", "visible");

                    showAndHideButton();
                }else{

                }
            });
    } else{

        var data={
            slug: slug
        };

        API.get("site/getOroscopoBranko", data, function (resp) {
            if(resp.status==1){
                console.log(resp);
                fillOroscopo(resp.oroscopo, id);
                $(".extend_player").css("visibility", "visible");
                showAndHideButton();
            }else{

            }
        });
    }

}

function fillOroscopo(resp, id){

    $("#podcast_append").empty();

        var single_oroscopo="";





            // if(current == false && !$(element).find(".podcast-play").hasClass("is-playing")){
            //     position = "prev_pod";
            // } else if(current == true){
            //     position = "next_pod"
            // } else if(current == false && $(element).find(".podcast-play").hasClass("is-playing")){
            //     current = true;
            //     position = "current_pod";
            //     playing = "is-playing";
            // }



        //     single_oroscopo+="<div class=\"other_podcast "+position+"\"> " +
        //         "<div class='flex align_center justify_between width_full'>" +
        //         "<span class=\"title_podcast_other font_14 bold dark_font sofia_font\">"+titolo+"</span>" +
        //         "<div class='flex align_center'>" +
        //         "<div class=\"podcast-play "+playing +" \" data-type=\"podcast\" data-id=\'\' data-cover=\'"+img+"\' data-slug=\'\' data-category=\'Oroscopo di Branko\' data-titolo=\'"+titolo+"\' data-giorno=\'"+data+"\' data-audio='"+audio+"' data-catSlug=\'oroscopo-di-branko\'></div>\n" +
        //         "<span style=\"margin-left: 11px;\" class=\"font_14 color_gray\">"+data+"</span>" +
        //         "</div>"+
        //         "</div>"+
        //         "</div>";
        // });

        var current = false;
        var position = "";
        for (let i = 0; i < resp.length; i++) {

            var playing = "";
                 if(current == false && id == resp[i].ID){
                position = "current_pod";
                current = true;
                playing = "is-playing";
            } else if(current ==  true && id != resp[i].ID){
                position = "next_pod";
            } else if(current ==  false && id != resp[i].ID){
                position = "prev_pod";
            }

            single_oroscopo+="<div class=\"other_podcast "+position+"\"> " +
                    "<div class='flex align_center justify_between width_full'>" +
                    "<span class=\"title_podcast_other font_14 bold dark_font sofia_font\">"+resp[i].post_title+"</span>" +
                    "<div class='flex align_center'>" +
                    "<div class=\"podcast-play "+playing +" is_oroscopo\" data-type=\"podcast\" data-id=\'"+resp[i].post_title+"\' data-cover=\'"+resp[i].img_src+"\' data-slug=\'\' data-category=\'Oroscopo di Branko\' data-titolo=\'"+resp[i].post_title+"\' data-giorno=\'\' data-audio='"+resp[i].audio_src+"' data-catSlug=\'oroscopo-di-branko\'></div>\n" +
                    "<span style=\"margin-left: 11px;\" class=\"font_14 color_gray\">"+resp[i].date+"</span>" +
                    "</div>"+
                    "</div>"+
                    "</div>";
        }

        $("#podcast_append").append(single_oroscopo);
        // $(".podcast_prev").addClass("disabled");
        // $(".podcast_next").addClass("disabled");
        // putCurrentInMiddle();
        // showCurrentPrevNext();

}

function showAndHideButton(){
    if($(".other_podcast.prev_pod").length == 0){
        $("#tasto_prev").addClass("disabled");
    } else{
        $("#tasto_prev").removeClass("disabled");
    }
    if($(".other_podcast.next_pod").length == 0){
        $("#tasto_next").addClass("disabled");
    } else{
        $("#tasto_next").removeClass("disabled");
    }
}

function getPodcastVideoRelated(slug, id){
    if(!slug){
        return;
    }
    var data={
        slug: slug,
        id_elem: id
    };
    API.get("site/getPodcastVideoListRelated", data, function (resp) {
            if(resp.status==1){

                fillListPodcastVideo(resp.podcasts);
            }else{

            }
        });
}

function fillListPodcast(result){
    var single_pod = "";
    var current="";

    var cover=$("#bottom_player_cover").attr("src");
    // window.object_podcast[result[0]["slug"]]["count"] = result[0]["count"] ;
    var array_slug = result[0]["post_slug"].split("/");
    array_slug.pop();
    var page_slug =array_slug.join("/");
    $("#counter_ep_ext").text(result[0]["count"]);
    $("#link_ep_ext").attr("href", page_slug);
    for (let i = 0; i < result.length; i++) {
        var single_res = result[i];
        var is_playing="";
        window.object_podcast[single_res["slug"]][i] = single_res["ID"];
        if(single_res["cid"]==0){
            current="current_pod";
            is_playing="is-playing";
        } else if(Math.sign(single_res["cid"]) == -1){
            current="next_pod";
        } else if(Math.sign(single_res["cid"]) == 1){
            current="prev_pod";
        }

        single_pod+="<div class=\"other_podcast "+current+"\">" +
                        "<div class='flex align_center justify_between width_full'>" +
                            "<span class=\"title_podcast_other font_14 bold dark_font sofia_font\">"+single_res["post_title"]+"</span>" +
                            "<div class='flex align_center'>" +
                                "<div class=\"podcast-play "+is_playing+" other_audio\" data-type=\"podcast\" data-id=\'"+single_res['ID']+"\' data-cover=\'"+cover+"\' data-slug=\'"+single_res['post_slug']+"\' data-category=\'"+Utils.quotesToHtmlEntities(single_res['page_title'])+"\' data-titolo=\'"+Utils.quotesToHtmlEntities(single_res['post_title'])+"\' data-giorno=\'"+single_res['post_date']+"\' data-audio='"+single_res['audio_src']+"' data-catSlug=\'"+single_res['slug']+"\'></div>\n" +
                                "<span style=\"margin-left: 11px;\" class=\"font_14 color_gray\">"+single_res["post_date"]+"</span>" +
                            "</div>"+
                        "</div>"+
                     "</div>";



    }

    $("img.podcast_prev").removeClass("disabled");

    $("#podcast_append").empty();
    $("#podcast_append").append(single_pod);


    //// gestire presenza del tasto back e prev


    showCurrentPrevNext();
}

function fillListPodcastVideo(result){
    var single_pod = "";
    var current="";
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-video", "");
    $("#next_podcast_play").find("img.podcast-video-image").attr("src", "");
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-category","");
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-titolo","");
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-giorno","");
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-id","");
    $("#next_podcast_play").find("img.podcast-video-image").attr("data-catName","");

    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-video", "");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("src", "");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-category","");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-titolo","");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-giorno","");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-id","");
    $("#prev_podcast_play").find("img.podcast-video-image").attr("data-catName","");

    for (let i = 0; i < result.length; i++) {
        var single_res = result[i];
        window.object_podcast[single_res["slug"]][i] = single_res["ID"];

        var video_aws_output = single_res["video_aws_output"];
        if(single_res["cid"]==0){
            current="current_pod";
        } else if(Math.sign(single_res["cid"]) == -1){
            current="next_pod";
            var data_video_obj={
                "type": "application/x-mpegurl",
                "src" : "https://video.rds.it/web/"+video_aws_output+"/hls_"+video_aws_output+".m3u8"
                };
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-video", JSON.stringify(data_video_obj));
            $("#next_podcast_play").find("img.podcast-video-image").attr("src", "https://video.rds.it/web/"+video_aws_output+"/720p/"+video_aws_output+"-00002.jpg");
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-category",single_res["slug"] );
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-titolo",single_res["post_title"] );
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-giorno",single_res["post_date"] );
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-id",single_res["ID"] );
            $("#next_podcast_play").find("img.podcast-video-image").attr("data-catName",single_res["category_name"] );
        } else if(Math.sign(single_res["cid"]) == 1){
            current="prev_pod";
            var data_video_obj={
                "type": "application/x-mpegurl",
                "src" : "https://video.rds.it/web/"+video_aws_output+"/hls_"+video_aws_output+".m3u8"
            };
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-video", JSON.stringify(data_video_obj));
            $("#prev_podcast_play").find("img.podcast-video-image").attr("src", "https://video.rds.it/web/"+video_aws_output+"/720p/"+video_aws_output+"-00002.jpg");
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-category",single_res["slug"] );
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-titolo",single_res["post_title"] );
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-giorno",single_res["post_date"] );
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-id",single_res["ID"] );
            $("#prev_podcast_play").find("img.podcast-video-image").attr("data-catName",single_res["category_name"] );



        }

    }
}

function showCurrentPrevNext(){
    if(window.innerWidth <= 550 && $("#full_player_bottom_inter").is(":visible")){
        $(".other_podcast").css("display", "flex");
        $("#podcast_append").animate({
            scrollTop: $(".current_pod").offset().top - $("#podcast_append").offset().top + $("#podcast_append").scrollTop()
        });
    } else if($("#full_player_bottom_inter").is(":visible") && window.innerWidth > 550){

        var index_current=$(".current_pod").index();
        if(index_current>=2){
            $(".other_podcast").eq(index_current-1).css("display", "flex");
            $(".other_podcast").eq(index_current-2).css("display", "flex");
        } else if(index_current==1){
            $(".other_podcast").eq(index_current-1).css("display", "flex");
        }
        $(".current_pod").nextAll(".other_podcast").css("display", "flex");
    }

}

$("img.podcast_next").on("click", function(){
    showNextLine();
});

$("img.podcast_prev").on("click", function(){
   showPrevLine();

});


function showNextLine(){
    $('.listato_podcast').find('.other_podcast:visible:first').hide();
    if($('.listato_podcast').find('.other_podcast:visible').length < 7 && !$("img.podcast_next").hasClass("disabled")){
        if(!window.is_oroscopo){
            callMorePodcast("append");
        }
        $("img.podcast_next").addClass("disabled");
    }
}
function showPrevLine(){
    $('.listato_podcast').find('.other_podcast:hidden:last').css("display", "flex");
    if($('.listato_podcast').find('.prev_pod:hidden').length < 5 && !$("img.podcast_prev").hasClass("disabled")){
        if(!window.is_oroscopo) {
         callMorePodcast("prepend");
        }
        $("img.podcast_prev").addClass("disabled");
    }
}

function callMorePodcast(type){

    var slug=$(".other_podcast:first").find(".podcast-play").attr("data-catSlug");
    var id=$(".other_podcast:first").find(".podcast-play").attr("data-id");
    if(type=="append"){
        id=$(".other_podcast:last").find(".podcast-play").attr("data-id");
    }
    var data={
        slug: slug,
        id_elem: id
    };
    API.get("site/getPodcastListRelated", data, function (resp) {

        if(resp.status==1){
            var cover=$("#bottom_player_cover").attr("src");

            console.log(resp.podcasts);
            var single_pod="";
            if(type=="prepend"){
                for (let i = 0; i < resp.podcasts.length; i++) {
                    var single_res = resp.podcasts[i];

                   if(Math.sign(single_res["cid"]) == 1){
                       single_pod+="<div class=\"other_podcast prev_pod\" >" +
                           "<div class='flex align_center justify_between width_full'>" +
                           "<span class=\"title_podcast_other font_14 bold dark_font sofia_font\">"+single_res["post_title"]+"</span>" +
                           "<div class='flex align_center'>" +
                           "<div class=\"podcast-play other_audio\" data-type=\"podcast\" data-id=\'"+single_res['ID']+"\' data-cover=\'"+cover+"\' data-slug=\'"+single_res['post_slug']+"\' data-category=\'"+single_res['page_title']+"\' data-titolo=\'"+single_res['post_title']+"\' data-giorno=\'"+single_res['post_date']+"\' data-audio='"+single_res['audio_src']+"' data-catSlug=\'"+single_res['slug']+"\'></div>\n" +
                           "<span style=\"margin-left: 11px;\" class=\"font_14 color_gray\">"+single_res["post_date"]+"</span>" +
                           "</div>"+
                           "</div>"+
                           "</div>";
                    }
                }

                $("#podcast_append").prepend(single_pod);

                var length_prev= resp.podcasts.map(function (f) {return f.cid }).filter(function (f, idx, arr) {return Math.sign(arr[idx]) == 1});
                if(length_prev.length < 4){
                    $("img.podcast_prev").addClass("disabled");
                } else{
                    $("img.podcast_prev").removeClass("disabled");

                }
            } else{

                for (let i = 0; i < resp.podcasts.length; i++) {
                    var single_res = resp.podcasts[i];

                    if(Math.sign(single_res["cid"]) == -1){
                        single_pod ="<div class=\"other_podcast next_pod\" style='display: flex;'>" +
                            "<div class='flex align_center justify_between width_full'>" +
                            "<span class=\"title_podcast_other font_14 bold dark_font sofia_font\">"+single_res["post_title"]+"</span>" +
                            "<div class='flex align_center'>" +
                            "<div class=\"podcast-play other_audio\" data-type=\"podcast\" data-id=\'"+single_res['ID']+"\' data-cover=\'"+cover+"\' data-slug=\'"+single_res['post_slug']+"\' data-category=\'"+single_res['page_title']+"\' data-titolo=\'"+single_res['post_title']+"\' data-giorno=\'"+single_res['post_date']+"\' data-audio='"+single_res['audio_src']+"' data-catSlug=\'"+single_res['slug']+"\'></div>\n" +
                            "<span style=\"margin-left: 11px;\" class=\"font_14 color_gray\">"+single_res["post_date"]+"</span>" +
                            "</div>"+
                            "</div>"+
                            "</div>";

                        $("#podcast_append").append(single_pod);
                    }
                }

                var length_next= resp.podcasts.map(function (f) {return f.cid }).filter(function (f, idx, arr) {return Math.sign(arr[idx]) == -1});
                if(length_next.length < 4){
                    $("img.podcast_next").addClass("disabled");
                }else{
                    $("img.podcast_next").removeClass("disabled");

                }


            }
            // $("img.podcast_next").removeClass("disabled");
            // $("img.podcast_prev").removeClass("disabled");

        }else{

        }
    });
}

$('#podcast_append').on('scroll', function() {
    if(window.innerWidth <= 550 && window.is_oroscopo == false){
        if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
            callMorePodcast("append");
            $("img.podcast_next").addClass("disabled");
            $(".other_podcast").css("display", "flex");
        } else if($(this).scrollTop() == 0){
            callMorePodcast("prepend");
            $("img.podcast_prev").addClass("disabled");
            $(".other_podcast").css("display", "flex");
        }
    }
});

window.showCurrentPrevNext = showCurrentPrevNext;

$(document).on('click','.download-podcast',(e) => {

    let uri = $(e.currentTarget).closest(".download-podcast-wrapper").find(".podcast-play").data("audio");
    let name = $(e.currentTarget).closest(".download-podcast-wrapper").find(".podcast-play").data("titolo");

    var link = document.createElement("a");
    link.href = "https://www.rds.it/rename_download_file?file="+uri+"&name="+name+"."+uri.split('.').pop();
    document.body.appendChild(link);
    link.click();
    link.remove();

});

$(document).on('click','.download-podcast-bottom',(e) => {

    let uri = playerPodcast.getSource();
    let name = $("#bottom_player_titolo").text();

    var link = document.createElement("a");
    link.href = "https://www.rds.it/rename_download_file?file="+uri+"&name="+name+"."+uri.split('.').pop();
    document.body.appendChild(link);
    link.click();
    link.remove();

});


function checkIfLoadMore(){
    if(!window.is_oroscopo){
        if($(".next_pod").length <= 3){
            callMorePodcast("append");
            // $("img.podcast_next").addClass("disabled");
        } else if($(".prev_pod").length <= 3){
            callMorePodcast("prepend");
            // $("img.podcast_prev").addClass("disabled");
        }
    }
}
